import { Component, OnInit, Input } from '@angular/core';
import { DataIoService } from '../../../../../services/data-io.service';

@Component({
	selector: 'iconbar',
	templateUrl: './iconbar.component.html',
	styleUrls: ['./iconbar.component.scss']
})

export class IconbarComponent implements OnInit {
	@Input('debug') debug : boolean = true;
	@Input('classes') classes :string ="";
	constructor(private ioService: DataIoService) { 
		
	}
	greenIq(){
		return this.ioService.getConfiguration().simulatorConfig.has('greeniq') && this.ioService.deviceInfo().getRawValue('greeniq')=='ENUM_GREEN_IQ_ON';
	}
	timerActive(){
		let mainZone = this.ioService.deviceInfo().getDefaultZoneId();
		return this.ioService.deviceInfo().getZoneById(mainZone).getRawValue('heatingmode')=="ENUM_HEATING_MODE_TIMECONTROLLED";
	}
	hasBattery(){
		return this.ioService.getConfiguration().simulatorConfig.hasBattery();
	}
	hasRadio(){
		return this.ioService.getConfiguration().simulatorConfig.hasRadio();	
	}
	serviceDateExpired(){
		return this.ioService.serviceDateExpired();
	}

	ngOnInit() {
	}

}
